export default "__VITE_ASSET__BnkmJYQT__"